<template>
  <div>
    <div v-if="toolTip" class="card-icon-dots" :v-tooltip="toolTip"> ...</div>
    <div v-else class="card-icon-dots"> ...</div>
  </div>
</template>
<script>
export default {
  name: "ThreeDots",
  props: {
    toolTip: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped src="./styles.scss" lang="scss"></style>
